import DynamicBadge, {
	type DynamicBadgeProps,
} from '@liquidweb-dev/undercurrent/DynamicBadge';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

export const AssetListItemStatus = ({ sx, ...rest }: DynamicBadgeProps) => (
	<DynamicBadge
		sx={combineSx(
			({ spacing }) => ({
				position: 'absolute',
				top: spacing(200),
				left: spacing(200),
			}),
			sx,
		)}
		{...rest}
	/>
);

export default AssetListItemStatus;
